import React, { useEffect, useRef } from 'react';
import { trackEvent } from '../lib/tracking';

export default function VideoTestimonialModal({ isOpen, onClose, videoSrc, posterSrc, title }) {
  const videoRef = useRef(null);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose();
    }
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
      trackEvent('testimonial_video_play', { title });
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose, title]);

  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title || 'Video testimonial'}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl bg-[#0f141c] rounded-2xl overflow-hidden shadow-2xl border border-white/10"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 bg-[#5A232E] text-white">
          <div className="flex items-center gap-2">
            <i className="fa-solid fa-circle-play text-[#5A232E]" aria-hidden="true" />
            <h3 className="text-sm font-medium truncate">{title || 'Video afspiller'}</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Luk video"
            className="p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
          >
            <i className="fa-solid fa-xmark text-lg" aria-hidden="true" />
          </button>
        </div>

        <div className="relative aspect-video bg-black flex items-center justify-center">
          {videoSrc ? (
            <video
              ref={videoRef}
              src={videoSrc}
              poster={posterSrc}
              controls
              autoPlay
              playsInline
              className="w-full h-full object-contain"
            >
              <track kind="captions" srcLang="da" label="Dansk" default />
              Din browser understøtter ikke videoafspilning.
            </video>
          ) : (
            <div className="p-8 text-center text-[#ECEEF1]/80">
              <i className="fa-solid fa-film text-4xl text-[#5A232E] mb-3 block" aria-hidden="true" />
              <p className="text-sm font-medium">Videomateriale publiceres snarest</p>
              <p className="text-xs text-white/60 mt-1">
                Video-testimonials tilføjes løbende med forudgående skriftligt klientsamtykke.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
